<template>
    <main id="page_sub">
      <section id="page_contents">
        <h5>비밀번호 재설정</h5>
        <span>사용하실 비밀번호로 재설정해주세요.<br>
          <span style="font-size:13px;">
            - 기존에 사용하셨던 비밀번호로 동일설정이 불가능합니다. <br>
            - 비밀번호는 8~20글자 영문, 숫자, 특수문자 조합으로 작성해주세요<br>
          </span>
        </span>
        <ul class="uBox p_first">
          <li>
            <!---기본정보 --->
            <div class="uw60">
              <label class="tla" for="">아이디</label>
              <span class="uinput">
              <input type="text" class="userInput" placeholder="hanulkim@etners.com" v-model="this.$store.state.userStore.userInfo.userId" disabled>
              </span>
            </div>
            <!---//기본정보 --->
            <!--- 사진영역  --->
            <div class="pro_photo" @click="handleClickButton" id="box_photo"> <a class="box_photo"><span>사진추가</span> </a>
           </div>
            <!---//사진영역  --->
            <div class="uw60 mt20">
              <p>
                <label class="tla" for="">비밀번호 재설정</label>
                <span class="uinput">
              <input  v-validate="'exist_password_confirmation'" name="exist_password_confirmation" data-vv-validate-on="change" type="password" class="userInput" v-model="existConfirmPassword" placeholder="기존 비밀번호를 입력해 주세요.">
              <font class="org" >{{ errors.first('exist_password_confirmation') }}</font></span> </p>
              <p>
                <label class="tla" for=""></label>
                <span class="uinput">
              <input  type="password" name="password" v-validate="'required|password'" class="userInput" placeholder="새 비밀번호를 입력해 주세요." data-vv-validate-on="change" v-model="userPwd" ref="password">
                 <font class="org" v-if="errors.has('password')">{{ errors.first('password') }}</font>
                </span> </p>
              <p>
                <label class="tla" for=""></label>
                <span class="uinput">
              <input  v-validate="'confirmed:password'" name="password_confirmation" data-vv-validate-on="change" type="password" class="userInput" placeholder="새 비밀번호를 한번 더 입력해 주세요." data-vv-as="password">


                  <font class="org" v-if="errors.has('password_confirmation')">{{ errors.first('password_confirmation') }}</font>

                </span> </p>



            </div>
            <!--- //비밀번호 재설정 --->
          </li>
        </ul>



      </section>


      <div class="clear"></div>
      <!--- 버튼영역 --->
      <div class="btn_area mt20">
        <button class="k-primary k-button k-big" data-role="button" role="button" aria-disabled="false" tabindex="0"  @click="uploadUserInfo">확인</button>
        <button data-role="button" class="k-button k-big" role="button" aria-disabled="false" tabindex="0">취소</button>
      </div>
      <!--- //버튼영역 --->
      <profile-upload-modal
        title="사진올리기" v-bind:file="uploads"
        :visible.sync="visible" @child="bindingFile">

      </profile-upload-modal>
    </main>

</template>


<script>
  import JwtService from "@/common/jwt.service";
  import Footer from "../../components/Footer";
  import {fetchUpdateFirstUserInfo} from "@/api/api.user"
  import { Validator } from "vee-validate";
  import ProfileUploadModal from "./ProfileUploadModal";
  export default {
    name    : 'UpdatePasswordForm',
    components: {
      Footer,
      ProfileUploadModal
    },
    created(){
      this.$store.dispatch('FETCH_USER')
    },
    data: () => ({
        existConfirmPassword : null,
        userPwd :null,
        visible: false,
        uploads : []
    }),
    methods : {
      handleClickButton(){
        this.visible = !this.visible

        if(this.uploads!==null&&this.visible) {
          const fileInfo = this.uploads[0];
          setTimeout(function () {
            if(fileInfo !== undefined) {
              const raw = fileInfo.rawFile;
              const name = fileInfo.name
              const reader = new FileReader();
              const w = this
              if (raw) {

                reader.onloadend = function () {

                  w.document.getElementById("previewImage").innerHTML = "<img alt=" + name + " src=" + this.result + " style='max-width:100%;max-height: 100%;'>"
                  w.document.getElementById("fileName").innerText = name
                  w.document.getElementById("fileSize").innerText = `${fileInfo.size}KB`
                };

                reader.readAsDataURL(raw);
              }
            }
          },300);
        }
      },
      bindingFile(fileInfo){
        this.uploads = fileInfo
        console.log(fileInfo)
        setTimeout(function() {
          const raw = fileInfo[0].rawFile
          const name = fileInfo[0].name
          const reader = new FileReader();
          const w = this
          if (raw) {

            reader.onloadend = function () {

              w.document.getElementById("box_photo").innerHTML = "<img alt="+name+" src="+this.result+" style='max-width:100%;max-height: 100%;'>"

            };

            reader.readAsDataURL(raw);
          }else{
            w.document.getElementById("box_photo").innerHTML = "<a class=\"box_photo\"><span>사진추가</span> </a>"
          }
        })
      },
      uploadUserInfo: function () {
        this.$validator.validateAll().then((result) => {
          if (result) {

            const data = new FormData()
            this.uploads.forEach(function(v){
              data.append("file",v.rawFile)
            })
            const userInfo = {"loginUserToken":JwtService.getToken(),userPwd:this.userPwd ,solCd:"0000"}
            data.append("userInfo",new Blob([JSON.stringify(userInfo)], {
              type: "application/json"
            }))


            fetchUpdateFirstUserInfo(data)
              .then(response=>{
                if(response.data.resultStatus.messageCode === "2000") {
                  this.$store.commit('SET_ISAUTHENTICATED')
                  this.$router.push({name: 'LoginSettingComplete'})
                }
            })

          }else{
            kendo.alert("필수 값들을 모두 입력해 주세요.")
          }
        })
      }
    },
    mounted() {
      const isUnique = value =>
        this.$store.dispatch('FETCH_CONFIRM_PASSWORD',{userPwd:value,loginUserToken:JwtService.getToken()})
          .then(resolve => {
            return resolve
          })


      Validator.extend("exist_password_confirmation", {
        validate: isUnique,
        getMessage: field => `기존 비밀번호와 맞지 않습니다. 기재한 비밀번호를 확인해 주세요.`,
      });

    /*  const chkIdCompare = value =>  {

        const passwordCharArr = [];
        let result =0
        for (let i = 0; i < value.length - 2; i++) {
          passwordCharArr.push(value.charAt(i) + value.charAt(i + 1) + value.charAt(i + 2))
        }
        let id = this.$store.state.userStore.userInfo.userId
        passwordCharArr.forEach(function (item) {
          if (id.indexOf(item) !== -1) {
            result = result + 1;
          }
        });

        return result === 0;
      }

      Validator.extend("chk_id_compare", {
        validate: chkIdCompare,
        getMessage: field => `아이디와 3자 이상 중복되면 안됩니다.`,
      });*/


    }
  }
</script>

<style>
  .close li {display: none;}
  .open li {display: block;}
</style>
